import { render, staticRenderFns } from "./FieldsetPaymentGeneral.yaml?vue&type=template&id=38133709&component"
import script from "./FieldsetPaymentGeneral.yaml?vue&type=script&lang=ts&component"
export * from "./FieldsetPaymentGeneral.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports